/* Galaxy Categories strip v3 — whole-page layout, prev/next + progress track with draggable thumb.
   rAF tween for programmatic scroll (scrollBy smooth is dead on this page). */
(function(){
  if(window.__gxCatbar) return; window.__gxCatbar = 1;
  function init(shell){
    var bar = shell.querySelector('.catbar');
    var prev = shell.querySelector('.catbar-nav--prev');
    var next = shell.querySelector('.catbar-nav--next');
    var track = shell.querySelector('.catbar-track');
    var thumb = shell.querySelector('.catbar-thumb');
    if(!bar) return;
    var ticking = false, lastKey = '';
    var MIN_W = 172;                       /* narrowest comfortable slot */
    function innerW(){
      var cs = getComputedStyle(bar);
      return bar.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    }
    /* Pick items-per-page so pages are full: e.g. 12 items, 10 fit -> 2 pages of 6. */
    function layout(){
      if(getComputedStyle(bar).display !== 'flex') return;   /* mobile grid: untouched */
      var cats = bar.querySelectorAll('.cat'), count = cats.length;
      var w = innerW(); if(!count || w < 50) return;
      var maxFit = Math.max(1, Math.floor(w / MIN_W));
      var pages = Math.max(1, Math.ceil(count / maxFit));
      var n = Math.ceil(count / pages);
      var slot = w / n;
      var key = n + ':' + Math.round(slot);
      if(key === lastKey) return; lastKey = key;
      bar.style.setProperty('--cat-n', n);
      var ic = Math.max(54, Math.min(84, slot * 0.3));
      bar.style.setProperty('--cat-ic', ic.toFixed(1) + 'px');
      bar.style.setProperty('--cat-fs', Math.max(12.5, Math.min(15, slot * 0.055)).toFixed(2) + 'px');
      bar.style.setProperty('--cat-gap', Math.max(9, Math.min(13, slot * 0.045)).toFixed(1) + 'px');
      cats.forEach(function(c, i){ c.classList.toggle('cat--snap', i % n === 0); });
    }
    function maxScroll(){ return bar.scrollWidth - bar.clientWidth; }
    function update(){
      ticking = false;
      var max = maxScroll(), x = bar.scrollLeft;
      shell.classList.toggle('no-scroll', max <= 2);
      if(prev) prev.disabled = x <= 2;
      if(next) next.disabled = x >= max - 2;
      if(thumb && bar.scrollWidth){
        var w = Math.max(12, bar.clientWidth / bar.scrollWidth * 100);
        thumb.style.width = w + '%';
        thumb.style.left = (max > 0 ? (x / max) * (100 - w) : 0) + '%';
      }
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
    function onResize(){ layout(); onScroll(); }
    function tween(to){
      var from = bar.scrollLeft, max = maxScroll();
      to = Math.max(0, Math.min(max, to));
      var d = to - from; if(!d) return;
      var t0 = performance.now(), dur = 380, done = false;
      function step(now){
        if(done) return;
        var p = Math.min(1, (now - t0) / dur);
        bar.scrollLeft = from + d * (1 - Math.pow(1 - p, 3));
        if(p < 1) requestAnimationFrame(step); else { done = true; update(); }
      }
      requestAnimationFrame(step);
      setTimeout(function(){ if(!done){ done = true; bar.scrollLeft = to; update(); } }, dur + 120);
    }
    function page(dir){
      var pw = innerW();
      var cur = Math.round(bar.scrollLeft / pw);
      tween((cur + dir) * pw);
    }
    if(prev) prev.addEventListener('click', function(){ page(-1); });
    if(next) next.addEventListener('click', function(){ page(1); });

    /* track: click to jump, drag thumb to scrub */
    if(track && thumb){
      var dragging = false, grabOffset = 0;
      function posToScroll(clientX){
        var r = track.getBoundingClientRect();
        var tw = thumb.getBoundingClientRect().width;
        var free = Math.max(1, r.width - tw);
        var p = (clientX - r.left - grabOffset) / free;
        return Math.max(0, Math.min(1, p)) * maxScroll();
      }
      track.addEventListener('pointerdown', function(e){
        e.preventDefault();
        var tr = thumb.getBoundingClientRect();
        var onThumb = e.clientX >= tr.left && e.clientX <= tr.right;
        grabOffset = onThumb ? (e.clientX - tr.left) : tr.width / 2;
        dragging = true; track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
        if(onThumb){ /* nothing yet */ } else { bar.scrollLeft = posToScroll(e.clientX); update(); }
      });
      track.addEventListener('pointermove', function(e){
        if(!dragging) return;
        bar.scrollLeft = posToScroll(e.clientX); update();
      });
      function endDrag(e){
        if(!dragging) return;
        dragging = false; track.classList.remove('is-dragging');
        try{ track.releasePointerCapture(e.pointerId); }catch(_){}
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      /* keyboard on the track */
      track.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); page(1); }
        if(e.key === 'ArrowLeft'){ e.preventDefault(); page(-1); }
      });
    }

    bar.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if(window.ResizeObserver){ new ResizeObserver(onResize).observe(bar); }
    bar.querySelectorAll('img').forEach(function(img){ if(!img.complete) img.addEventListener('load', onScroll, { once: true }); });
    layout(); update();
  }
  function boot(){ document.querySelectorAll('.catbar-shell').forEach(function(s){ if(!s.dataset.gxInit){ s.dataset.gxInit = '1'; init(s); } }); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
